

import React from "react";
import { Link } from "react-router-dom";
import style from '../../../css/dashboard/News_event.module.css';

const News_event = () => {
  return (
    <div className={style.cardGridcardcontainer}>
    
      <div className={style.cardGrid}>
        <Link to="company_news" className={style.card}>
          <div className={style.cardContent}>
            <h3>company news</h3>
          </div>
        </Link>
        <Link to="company_earning" className={style.card}>
          <div className={style.cardContent}>
            <h3>company earning</h3>
          </div>
        </Link>
        <Link to="Economy_mktpulse_news" className={style.card}>
          <div className={style.cardContent}>
            <h3>Economy Market pulse</h3>
          </div>
        </Link>
        <Link to="Economy_indmkt_news" className={style.card}>
          <div className={style.cardContent}>
            <h3>Economy india market</h3>
          </div>
        </Link>
        <Link to="Economy_inflation_news" className={style.card}>
          <div className={style.cardContent}>
            <h3>Economy inflation</h3>
          </div>
        </Link>
        <Link to="Equity_corporate_news" className={style.card}>
          <div className={style.cardContent}>
            <h3>Equity Corporate news</h3>
          </div>
        </Link>
        <Link to="Equity_corporate_result" className={style.card}>
          <div className={style.cardContent}>
            <h3>Equity Corporate news</h3>
          </div>
        </Link>
        <Link to="Equity_global_news" className={style.card}>
          <div className={style.cardContent}>
            <h3>Equity global news</h3>
          </div>
        </Link>
        <Link to="Ipo_analysis_news" className={style.card}>
          <div className={style.cardContent}>
            <h3>IPO ANALYSIS</h3>
          </div>
        </Link>
        <Link to="Ipo_news" className={style.card}>
          <div className={style.cardContent}>
            <h3>IPO NEWS</h3>
          </div>
        </Link>
      </div>
    </div>
  );
};

export default News_event;
